/* Gold full-width banner above the header while previewing (TEST1). */
.banner {
  background: var(--brand-gold);
  color: var(--brand-navy-950);
}

.inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  max-width: var(--container-max);
  min-height: 56px;
  margin: 0 auto;
  padding: 6px var(--content-gutter);
  font-size: 15px;
  line-height: 1.4;
}

.text {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0;
}

/* APP-122: who is really signed in, under "Acting as …". */
.note {
  flex-basis: 100%;
  font-size: 14px;
}

.actions {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.change,
.exit {
  display: inline-flex;
  align-items: center;
  min-height: var(--control-height);
  padding: 0 14px;
  border: 1px solid var(--brand-navy-950);
  border-radius: var(--radius-sm);
  background: var(--brand-navy-950);
  color: var(--white);
  font-family: var(--font-ui);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
}

.change {
  background: transparent;
  color: var(--brand-navy-950);
}

.change[data-hovered] {
  background: var(--navy-a08);
}

.exit[data-hovered] {
  background: var(--brand-navy-700);
}

.change[data-focus-visible],
.exit[data-focus-visible] {
  outline: 2px solid var(--brand-navy-950);
  outline-offset: 2px;
}
